module.exports = __webpack_public_path__ + "static/all-that-i-am-eb50312ab7737cffaa9fc5686d2e0584.jpg";